(function () {
  'use strict';
  const dataNode = document.getElementById('bcf-lite-data');
  const form = document.getElementById('bcf-buy-form');
  const wrap = document.getElementById('bcf-lite');
  const root = document.querySelector('[data-bcf-pdp][data-bcf-family]');
  const api = window.BCFFamilyPDP;
  if (!dataNode || !form || !wrap || !root || !api) return;
  const D = JSON.parse(dataNode.textContent);
  document.body.setAttribute('data-bcf-family-stack', '');
  const query = new URLSearchParams(location.search);
  const st = { on: query.get('offer') === 'pair', len: D.sub[query.get('040')] ? query.get('040') : '18', adjust: query.get('adjust') === '1' };
  form.parentNode.insertBefore(wrap, form);
  if (!wrap.querySelector('#bundle-heading')) { const heading = document.createElement('h2'); heading.id = 'bundle-heading'; wrap.querySelector('#offers').before(heading); }
  const money = c => '$' + (c % 100 ? (c / 100).toFixed(2) : c / 100);
  const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const idInput = () => form.querySelector('[name="id"]');
  const mainV = () => D.main[String(idInput()?.value)];
  const subV = () => D.sub[st.len];
  const discount = v => Math.round(v.price * (100 - D.pct) / 100);
  const active = () => st.on && mainV()?.available && subV()?.available;
  let busy = false;
  let sawDisabled = false;
  function url() {
    const u = new URL(location.href);
    u.searchParams.set('offer', active() ? 'pair' : 'single');
    u.searchParams.set('040', st.len);
    if (st.adjust) u.searchParams.set('adjust', '1'); else u.searchParams.delete('adjust');
    history.replaceState({}, '', u);
  }
  function label() {
    if (busy || !mainV()) return;
    const total = active() ? mainV().price + discount(subV()) : mainV().price * api.state.qty;
    const title = 'Add ' + (active() ? '2 chains' : (api.state.qty === 1 ? '1 chain' : api.state.qty + ' chains')) + ' — ' + money(total);
    [...form.querySelectorAll('[data-atc]'), ...document.querySelectorAll('[data-sticky-atc]')].forEach(b => {
      if (b.textContent !== title) b.textContent = title;
    });
    const family = window.BCFFamilyCatalog.families[root.dataset.bcfFamily];
    const name = family.widths[api.state.width].role;
    const setText = (selector, value) => { const node = document.querySelector(selector); if (node && node.textContent !== value) node.textContent = value; };
    setText('.minimal-sticky-add strong', active() ? '2 chains' : name);
    setText('[data-sticky-selection]', name + ' ' + api.state.length + '″' + (active() ? ' · Subtle ' + st.len + '″' : ''));
  }
  function sync() {
    root.querySelectorAll('[data-qty]').forEach(b => { b.disabled = !!active() || busy; });
    if (active()) { api.state.qty = 1; const qv = root.querySelector('#qv'); if(qv) qv.textContent = '1'; const q = form.querySelector('[name="quantity"]'); if(q) q.value = '1'; }
    form.querySelectorAll('[data-bcf-lite-input]').forEach(n => n.remove());
    const id = idInput(), q = form.querySelector('[name="quantity"]');
    if (id) id.disabled = !!active();
    if (q) q.disabled = !!active();
    if (active()) {
      const put = (name, value) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = name; i.value = value; i.dataset.bcfLiteInput = ''; form.appendChild(i); };
      [[id.value, 'main'], [subV().id, 'addon']].forEach(([variant, role], i) => {
        put(`items[${i}][id]`, variant); put(`items[${i}][quantity]`, 1);
        put(`items[${i}][properties][_bcf_offer]`, 'subtle-addon'); put(`items[${i}][properties][_bcf_role]`, role);
      });
      put('items[1][properties][Length]', st.len + ' inches');
    }
    label();
  }
  function gallery(show) {
    const maxLength = active() ? Math.max(Number(api.state.length),Number(st.len)) : Number(api.state.length);
    let focus = root.dataset.bcfFamily === "curb" ? (maxLength >=24 ? 55 : maxLength >=22 ? 50 : 45) : (maxLength >=24 ? 80 : maxLength >=22 ? 76 : 68);
    // The approved models have different framing; keep both selected chain ends visible.
    if (root.dataset.bcfFamily === 'curb' && maxLength >= 24) {
      if (api.state.width === '100') focus = Number(api.state.length) === 24 ? 75 : 65;
      if (api.state.width === '120') focus = 75;
    }
    if (root.dataset.bcfFamily === 'curb' && api.state.width === '180') focus = 75;
    if (root.dataset.bcfFamily === 'figaro') {
      if (api.state.width === '150') focus = Number(api.state.length) === 24 ? 65 : maxLength >= 22 ? 55 : 50;
      if (api.state.width === '180') focus = maxLength >= 24 ? 70 : maxLength >= 22 ? 65 : 60;
    }
    root.style.setProperty("--bcf-stack-focus", focus + "%");
    const first = root.querySelector('.gal .thumbs button');
    const standard = api.galleryFrames()[0];
    if (!first || !standard) return;
    const frame = active() ? {kind:'model', src:D.assetBase + `bcf-stack-${root.dataset.bcfFamily}-${api.state.width}-${api.state.length}-${st.len}.jpg`, alt:`${root.dataset.bcfFamily === 'curb' ? 'Curb' : 'Figaro'} ${api.state.length} inch with Subtle Rope ${st.len} inch — styling preview`, label:'Everyday stack'} : standard;
    const thumb = first.querySelector('img');
    if (thumb) thumb.src = frame.src;
    first.dataset.full = frame.src;
    first.setAttribute('aria-label', 'View ' + (active() ? frame.alt : standard.label));
    if (show) api.showGalleryFrame(frame, first);
    let caption = root.querySelector('.bcf-stack-image-caption');
    if (!caption) { caption = document.createElement('p'); caption.className = 'bcf-stack-image-caption'; root.querySelector('.gal .main')?.after(caption); }
    caption.textContent = frame.alt + " · Fit varies.";
    caption.hidden = !active() || !show;
  }
  function render(showImage) {
    const m = mainV(), s = subV();
    const family = window.BCFFamilyCatalog.families[root.dataset.bcfFamily];
    const width = family.widths[api.state.width], variant = width.variants[api.state.length];
    const widthHead = root.querySelector('#widths')?.previousElementSibling;
    if (widthHead) { widthHead.querySelector('.t').textContent = 'Width · ' + width.role.replace(' ' + family.label, ''); widthHead.querySelector('.hint').textContent = variant.grams.toFixed(1) + ' g at ' + api.state.length + '″'; }
    const lengthHead = root.querySelector('#lens')?.previousElementSibling;
    if (lengthHead) lengthHead.querySelector('.t').textContent = 'Length';
    wrap.hidden = !m;
    if (!m) { st.on = false; sync(); gallery(true); return; }
    if (!s?.available || !m.available) st.on = false;
    const pills = ['18','20','22','24'].map(n => `<button type="button" class="length-option" data-act="len" data-len="${n}" aria-pressed="${st.len === n}" ${D.sub[n]?.available ? '' : 'disabled'}>${n}″</button>`).join('');
    wrap.querySelector('#bundle-heading').textContent = 'Add a second silver chain for ' + (s ? money(discount(s)) : 'less');
    wrap.querySelector('#offers').innerHTML = `
      <article class="offer ${st.on ? '' : 'selected'}"><button type="button" class="bcf-lite-single" data-act="single" aria-pressed="${!st.on}"><span class="radio" aria-hidden="true"></span><strong>1 chain</strong><span class="bcf-lite-price">${money(m.price)}</span></button><div class="offer-components" data-offer="single"><span class="offer-component"><span class="component-photo"><img src="${esc(api.galleryFrames()[0].src)}" alt="${esc(width.role)}" width="36" height="36"></span><span class="component-name">${esc(width.role)}</span><span class="component-length">${api.state.length}″ · Your chain</span></span></div></article>
      <article class="offer bcf-addon ${st.on ? 'selected' : ''}">
        <div class="bcf-stack-banner">Save ${D.pct}% on your second chain</div>
        <button type="button" class="bcf-addon-choice" role="checkbox" aria-checked="${st.on}" data-act="toggle" ${s?.available && m.available ? '' : 'disabled'}>
          <span class="bcf-addon-check" aria-hidden="true">${st.on ? '✓' : ''}</span><span class="bcf-addon-description"><strong>Everyday stack</strong></span>
          <span class="bcf-addon-price"><strong>${s ? money(m.price + discount(s)) : 'Unavailable'}</strong>${s ? `<del>${money(m.price + s.price)}</del>` : ''}</span>
          <span class="bcf-stack-subtitle">Your chain + Subtle Rope${s ? ` for <b>+${money(discount(s))}</b>` : ''}</span>
        </button>
        <ul class="bcf-stack-benefits"><li><span aria-hidden="true">✓</span>Two solid 925 silver chains</li><li><span aria-hidden="true">✓</span>Free shipping</li><li><span aria-hidden="true">✓</span>Polishing kit <small>$15 value</small></li><li><span aria-hidden="true">✓</span>Gift box <small>$10 value</small></li></ul>
        <div class="bcf-addon-fit"><div class="bcf-stack-fit-row"><span>Subtle Rope · ${st.len}″</span><button type="button" class="text-button" data-act="adjust" aria-expanded="${st.adjust}">${st.adjust ? 'Done' : 'Change length'}</button></div><div class="offer-length-editor" ${st.adjust ? '' : 'hidden'}><div class="length-options" aria-label="Subtle Rope length">${pills}</div></div></div>
      </article><p class="bcf-stack-terms">One discounted add-on per order.</p>`;
    sync(); gallery(showImage); url();
  }
  wrap.addEventListener('click', e => {
    const b = e.target.closest('[data-act]'); if (!b || b.disabled || busy) return;
    const act = b.dataset.act;
    if (act === 'toggle') st.on = !st.on;
    if (act === 'single') st.on = false;
    if (act === 'adjust') st.adjust = !st.adjust;
    if (act === 'len') st.len = b.dataset.len;
    // Pair quantity is one main plus one add-on. Never multiply an existing quantity.
    if (st.on) { api.state.qty = 1; const q = form.querySelector('[name="quantity"]'); if (q) q.value = '1'; }
    render(act !== 'adjust');
    const replacement = wrap.querySelector(`[data-act="${act}"]${act === 'len' ? `[data-len="${st.len}"]` : ''}`);
    replacement?.focus({preventScroll:true});
  });
  root.querySelector('.gal .thumbs')?.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (active() && b === root.querySelector('.gal .thumbs button')) { e.preventDefault(); e.stopImmediatePropagation(); gallery(true); }
    else { const c = root.querySelector('.bcf-stack-image-caption'); if (c) c.hidden = true; }
  }, true);
  root.addEventListener('bcf:variant-change', () => setTimeout(() => render(true), 0));
  root.addEventListener('bcf:quantity-change', () => { if (active()) api.state.qty = 1; sync(); });
  root.addEventListener('click', e => { if ((busy && e.target.closest('button')) || (active() && e.target.closest('[data-qty]'))) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  document.addEventListener('submit', e => { if (e.target === form && !busy) { sync(); busy = true; sawDisabled = false; wrap.setAttribute('aria-busy','true'); } }, true);
  // Native Shopify navigation normally leaves the page. If AJAX completes, unlock on its button state.
  new MutationObserver(() => { if (busy && form.querySelector('[data-atc]')?.disabled) sawDisabled = true; if (busy && sawDisabled && !form.querySelector('[data-atc]')?.disabled) { busy = false; wrap.removeAttribute('aria-busy'); } label(); }).observe(form, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled']});
  render(true);
  // The shared sticky purchase bar is created by a later deferred script.
  document.addEventListener('DOMContentLoaded', sync, {once:true});
})();
